import {
  UpdateCandidateDocument,
  UpdateCandidateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import type { Candidate } from 'modules/ats/hooks/candidates/useCandidate'

type UpdateCandidateInput = Omit<UpdateCandidateMutationVariables, 'id'>

type PartialCandidate = Pick<Candidate, 'id'>

export const useUpdateCandidate = (candidate: PartialCandidate) => {
  const [update, { loading }] = useMutation(UpdateCandidateDocument, {
    extractorFn: (data) => data.atsMutations.updateAtsCandidate,
  })

  return {
    loading,
    updateCandidate(variables: UpdateCandidateInput) {
      return update({
        variables: { id: candidate.id, ...variables },
      })
    },
  }
}
